export enum ChipTypeaheadDesignEnum {
	DEFAULT = 'chip',
	LIST = 'list',
	NONE = 'none',
}
